function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        active: {
            default: true
        }
    },
    data: function data() {
        return {
            headers: ["Account Number", "Name", "DBA", "Address", "City", "State"],
            fields: ["id", "name", "dba_name", "address", "city", "state"],
            items: [],
            show: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        $el.load(0);
        $el.show = true;

        Event.$on('load-vendor-list', function () {
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var search = arguments[1];
            var sort = arguments[2];
            var order = arguments[3];
            var isDate = arguments[4];

            $el.load(offset, search, sort, order, isDate);
            $el.show = true;
            Event.$emit('hide-archive-vendor-list');
        });

        Event.$on('hide-vendor-list', function () {
            return _this.show = false;
        });

        Event.$on('delete-vendor', function (item) {
            Event.$emit('confirm-delete', item, '', 'remove-vendor', 'Do you want to archive this vendor?', 'Yes');
        });

        Event.$on('remove-vendor', function (item) {
            var $el = _this;
            axios.delete("/prototype/vendors/" + item.id).then(function () {
                var $idx = $el.items.findIndex(function (i) {
                    return i.account_number === item.account_number;
                });
                $el.items.splice($idx, 1);
            });
        });
    },

    methods: {
        load: function load(offset) {
            var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
            var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DESC';
            var isDate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


            Event.$emit('data-table-loading');

            var self = this;
            var data = {
                offset: offset,
                search: search,
                sort: sort,
                order: order,
                isDate: isDate
            };

            axios.post("/prototype/vendors/list/1", data).then(function (response) {

                offset !== 0 ? self.items = [].concat(_toConsumableArray(self.items), _toConsumableArray(response.data)) : self.items = response.data;

                self.items.map(function (vendor) {
                    if (vendor.contacts.length) {
                        vendor['contact'] = vendor.contacts[0].name;
                    }
                });

                Event.$emit('data-table-loaded');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/vendors/VendorList.vue
// module id = wRLk
// module chunks = 0 1